import { getLocalCurrencyStr } from '@beef/utils';
import { DateTime } from 'luxon';

export const isEmptyValue = (value: string): boolean =>
  ['', null, undefined, '{}'].includes(value) === true ||
  (Array.isArray(value) === true && value.length === 0) ||
  (typeof value === 'object' && Object.keys(value).length === 0);

export const getFormattedTariffName = (name: string = '') => {
  if (!name) {
    return name;
  }

  const [first, ...rest] = name.split(' ');
  return [first.toLowerCase(), ...rest].join(' ');
};

export const getUnbilledChargesText = (
  showUnbilledCharges: boolean,
  nextBillingDate: null | string,
  sum?: number,
) => {
  if (!showUnbilledCharges) {
    return '';
  }
  const text = `расходы на сегодня — ${getLocalCurrencyStr(sum)}`;
  return nextBillingDate ? `${text},` : text;
};

export const formatDateString = (date: string, formatString: string) => {
  if (!date) {
    return null;
  }

  if (formatString === 'time') {
    return DateTime.fromISO(date).setLocale('ru-RU').toLocaleString(DateTime.TIME_24_SIMPLE);
  }

  return DateTime.fromISO(date).toLocaleString();
};

export const formatLongDate = (date: Date | string) => {
  const currentDate = new Date(date);
  return currentDate.toLocaleString('ru-RU', {
    month: 'long',
    day: 'numeric',
  });
};

export const getWriteOffText = (billingDate?: string, period?: number) => {
  const range = period === 1 ? 'в сутки' : 'в месяц';
  const periodDays = period ? range : '';
  return billingDate ? formatLongDate(billingDate) : periodDays;
};
